import { IRequirementsTemplate } from 'APIPackage/AccountModule/interfaces/IRequirementsTemplate';

import { IRequirementTemplateSelectOption } from '../interfaces/IRequirementTemplateSelectOption';

export function createRequirementTemplateSelectOption(
  requirementTemplate: IRequirementsTemplate,
): IRequirementTemplateSelectOption {
  return {
    ...requirementTemplate,
    label: requirementTemplate.name,
    value: requirementTemplate.id,
  };
}
